// components/RemarkDialog.tsx
import { use } from 'i18next';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EligibilityResponse } from 'src/app/interfaces/ApiResponse';
import { getPlanSupportedCountries } from 'src/app/services/PlanService';

interface DialogProps {
  visible: boolean;
  onClose: () => void;
  header: string;
  data: EligibilityResponse | null;
}

const NotEligibleDialog: React.FC<DialogProps> = ({
  visible,
  onClose,
  header,
  data
}) => {
  const toast = useRef<Toast>(null);
  const [countries, setCountries] = useState<any>([]);
  const [search, setSearch] = useState('');
  const { t } = useTranslation();

  const handleHide = () => {
    onClose();
  };

  useEffect(() => {
    console.log('data ', data);
  }, [data]);




  return (
    <>
      <Toast ref={toast} />
      <Dialog
        style={{ width: '35vw' }}
        breakpoints={{ '960px': '75vw', '641px': '100vw' }}
        visible={visible}
        onHide={handleHide}
        // header={header}
        dismissableMask
        closable={false}
      >
        <div className="w-full py-2 ">
          <div className="grid">
            <div className="col-12 lg:col-12 px-2">


              <div className="text-center">
                <i
                  className="pi  pi-times-circle text-center"
                  style={{ color: '#FF4444', fontSize: '2.5rem' }}
                ></i>
              </div>

              <h3 className="mb-3 text-center font-bold">{t('landing.esim_ineligible.sorry_title')}</h3>

              <p className="mb-5 text-center font-bold">
                {/* {t('landing.esim_ineligible.ineligible_message')} */}
                {data?.message}
              </p>

              <p className="mb-5 text-center">
                {t('landing.esim_ineligible.instruction_message')}
              </p>

              <div className="flex flex-row gap-2">
                <Button className="w-full" label={t('landing.esim_ineligible.understood_button')} onClick={() => handleHide()} />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default NotEligibleDialog;
